import React from "react";

import { Card, CardContent, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";

export const SudHoverCard = ({ context }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        backgroundColor: theme.palette.background.secondary,
        borderRadius: 0,
        backgroundImage: "none",
      }}
    >
      <CardContent>
        <Typography component="div" variant="body1">
          {context}
        </Typography>
        <Typography component="div" variant="caption">
          Click to find out more...
        </Typography>
      </CardContent>
    </Card>
  );
};
